import { lazy, Suspense, useState } from 'react';
import Header from "../../shared/Header";
import Hero16 from "../hero/hero-16";
import JandiHelp from "./JandiHelp";
import { InlineLazyFallback } from "@/shared/RouteLoadingFallback";
import AnnouncementBar from "./AnnouncementBar";
import Popup from "../../shared/popups/popupDetails";

const Register = lazy(() => import("@/pages/auth/register"));

type HomePageProps = {
  initialWorkers?: any;
};

const HomePage = ({ initialWorkers }: HomePageProps) => {
  // State for registration popup
  const [registerPopupShow, setRegisterPopupToggle] = useState(false);
  const [registerType, setRegisterType] = useState("");
  
  // State for login popup (if needed)
  const [loginPopupShow, setLoginPopupToggle] = useState(false);

  const handleOpenRegister = (type) => {
    console.log("Register type:", type); // Debugging
    setRegisterType(type);
    setRegisterPopupToggle(true);
  };
  const handleRegistrationSuccess = () => {
    setRegisterPopupToggle(false); // Close popup
    // Optional: show welcome message or redirect
  //  toast.success("Welcome! Registration successful.");
  };
  const handleOpenLogin = () => {
    setLoginPopupToggle(true);
  };

  return (
    <>
      <AnnouncementBar />
      <Hero16 initialWorkers={initialWorkers} />
      <JandiHelp />
      
      {/* Registration Popup */}
      <Popup
        size={'sm'}
        className="bg-darkBlue"
        headerTitle=""
        isOpen={registerPopupShow}
        handleSubmit={() => {}}
        handleClose={() => setRegisterPopupToggle(false)}
        bodyChildren={
          registerPopupShow ? (
            <Suspense fallback={<InlineLazyFallback />}>
              <Register
                handlePopupType={(type) => {
                  if (type === 'login') {
                    setRegisterPopupToggle(false);
                    setLoginPopupToggle(true);
                  }
                }}
                RegisterType={registerType}
                onSuccess={handleRegistrationSuccess}
              />
            </Suspense>
          ) : null
        }
      />
      
      {/* Login Popup (if needed) */}
      {/* <LoginPopup
        isOpen={loginPopupShow}
        onClose={() => setLoginPopupToggle(false)}
      /> */}
    </>
  );
};

export default HomePage;